// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"962a5bff","574":"1c5a9546"}[chunkId] + ".chunk.js";
};